// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__UlMis","wrapper":"Footer_wrapper__vE6pW","list":"Footer_list__FpgDV","logo":"Footer_logo__7fjus","social":"Footer_social__-pCP7","copy":"Footer_copy__Qvv2U"};